import { LocalCredentialsStorage } from './session-management/domain/repositories/storage/local-credentials-storage';

require('./session-management/index');
require('./student');
require('./wishlist-service');
